export const DEFAULT_BRANDING = {
    primaryColor: '#2563eb',
    secondaryColor: '#2563eb',
    textSecondary: '#6b7280',
    grey300: '#d1d5db',
};
